import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { VoiceWaveImage } from './styled';

const RecordingIndicator = ({ recording }) => {
  const [visible, setVisible] = useState(recording);
  useEffect(() => {
    if (recording) { setVisible(true); return undefined; }
    const timeout = setTimeout(() => setVisible(false), 350);
    return () => clearTimeout(timeout);
  }, [recording]);
  if (!visible) return null;
  return (
    <VoiceWaveImage src={require('../../static/img/animation/voicewave.gif')} alt="Voice activity"
      style={{ opacity: recording ? 1 : 0, transform: recording ? 'scale(1)' : 'scale(0.94)', transition: 'opacity 350ms ease-out, transform 350ms ease-out' }} />
  );
};
RecordingIndicator.propTypes = { recording: PropTypes.bool.isRequired };
export default RecordingIndicator;
